import React from "react";

import { Input } from "antd";

export default class InputNumerico extends React.Component {

  constructor(props) {
    super(props);
    const { id, placeholder, value, max } = props;
    this.state = {value: value, id: id, placeholder: placeholder, max: max};
  }
  
  onChange = (event) => {
    
    let max = this.state.max;
    let valor = event.target.value.length > max ? this.state.value : event.target.value;
    const re = /^[0-9\b]+$/;
    
    if (valor === '' || re.test(valor)) {
       this.setState({value: valor});
       this.props.onChange(event)
    }
  };


  render() {
    return (<Input allowClear id={this.state.id} type="number" maxLength={this.state.max} placeholder={this.state.placeholder} style={{ width: '100%' }} value={this.state.value} onChange={this.onChange} /> 
      );
  }
}
